<ion-app>
	<ion-router-outlet
		id="main"
		[swipeGesture]="swipeGesturesEnabled"
	></ion-router-outlet>
</ion-app>
